module.exports = __webpack_public_path__ + "static/media/online-work.f6a295dc.svg";